import React, { Fragment, useCallback, useEffect } from 'react'
import { Table, Button } from 'antd'
import { connect } from 'dva'
import PageTable from '@/components/PageTable'
import './Team.module.less'

const { Column } = Table

const TeamManagement = ({
  dispatch,
  teamManagementPagination,
  teamManagementData,
}) => {
  const handleTableChange = (option) => {
    dispatch({
      type: 'center/save',
      payload: {
        teamManagementPagination: {
          ...teamManagementPagination,
          current: option.current,
          pageSize: option.pageSize,
        },
      },
    })
    dispatch({
      type: 'center/getTeamApplications',
    })
  }

  const handleCheckProfile = useCallback(
    (item, status) => {
      const formData = new FormData()
      formData.append('id', item.id)
      formData.append('action', status === 'accept' ? 1 : 2)
      dispatch({
        type: 'center/upudateTeamApplication',
        payload: {
          params: formData,
        },
      }).then(() => {
        dispatch({
          type: 'center/getTeamApplications',
        })
      })
    },
    [dispatch]
  )

  useEffect(() => {
    dispatch({
      type: 'center/getTeamApplications',
    })
  }, [dispatch])

  return (
    <PageTable
      onChange={handleTableChange}
      pagination={teamManagementPagination}
      rowKey="id"
      dataSource={teamManagementData}
      style={{ marginTop: '20px' }}
    >
      <Column
        title="成员昵称"
        dataIndex="applicantNickname"
        key="applicantNickname"
      />
      <Column title="电话" dataIndex="applicantPhone" key="applicantPhone" />
      <Column title="申请时间" dataIndex="createdAt" key="createdAt" />
      <Column
        width={200}
        title="操作"
        key="operatioin"
        render={(text, record) => (
          <div>
            {record.applyStatus === 0 ? (
              <Fragment>
                <Button
                  onClick={() => handleCheckProfile(record, 'accept')}
                  type="primary"
                >
                  通过
                </Button>
                <Button
                  onClick={() => handleCheckProfile(record, 'refuse')}
                  style={{ marginLeft: '12px' }}
                >
                  拒绝
                </Button>
              </Fragment>
            ) : (
              <span>{record.applyStatus === 1 ? '已通过' : '已拒绝'}</span>
            )}
          </div>
        )}
      />
    </PageTable>
  )
}

export default connect(({ center }) => {
  return {
    teamManagementPagination: center.teamManagementPagination,
    teamManagementData: center.teamManagementData,
  }
})(TeamManagement)
